"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _Details = require("./Details");
Object.keys(_Details).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Details[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _Details[key];
    }
  });
});
var _constants = require("./constants");
Object.keys(_constants).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _constants[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _constants[key];
    }
  });
});
